import { OnChanges, SimpleChanges } from '@angular/core';
import { Component, Input, OnInit } from '@angular/core';
import { EntityPagedRequestParameters } from "@bndes/bndes-ux4/bndes-angular-utils";
import { IrregularidadeEmpresaDTO } from 'src/app/model/irregularidade-empresa.model';

@Component({
    selector: 'app-irregularidade-empresa-listagem',
    templateUrl: './irregularidade_empresa.listagem.component.html',
    styleUrls: ['./irregularidade_empresa.listagem.component.scss'],
    standalone: false
})
export class IrregularidadeEmpresaListagemComponent implements OnInit, OnChanges {

  @Input() public empresa: IrregularidadeEmpresaDTO[];
  @Input() public atributosPaginacao: EntityPagedRequestParameters;
  public opcoesPaginacao: number[];
  public listaEmpresa: any[];
  public countEmpresa: number;


  ngOnInit(): void {
    this.opcoesPaginacao = [10, 20, 30];
    this.atributosPaginacao = {
      page: 1,
      pageSize: this.opcoesPaginacao[0]
    };
  }

  ngOnChanges(changes: SimpleChanges): void{

    //this.navegar(this.atributosPaginacao);
  }

  public mudancaPagina(novaPagina: EntityPagedRequestParameters) {

    this.atributosPaginacao = novaPagina;
    this.navegar(this.atributosPaginacao);
  }

  public navegar(pesq: EntityPagedRequestParameters) {

    let posInicial: number, posFinal: number;

    posInicial = (pesq.page-1) * pesq.pageSize;
    posFinal = posInicial + pesq.pageSize;

    if (posFinal > this.empresa.length) {
      posFinal = this.empresa.length;
    }

    this.listaEmpresa = this.empresa.slice(posInicial, posFinal);
    this.countEmpresa = this.empresa.length;
  }

}
